export type FilterConfigBarItem =
    | FilterConfigBarItemDefault
    | FilterConfigBarItemMultiple
    | FilterConfigBarItemPrice
    | FilterConfigBarItemSearchable;

interface FilterConfigBarItemBase {
    /** The key used for filtering data, usually matched to the same key on search service BE */
    filterKey: string;
    /** Optional label to display for the filter */
    label?: string;
}

export interface FilterConfigBarItemDefault extends FilterConfigBarItemBase {
    type: 'default';
    hideWhenEmpty?: boolean;
}

export interface FilterConfigBarItemMultiple extends FilterConfigBarItemBase {
    type: 'multiple';
}

export interface FilterConfigBarItemPrice extends FilterConfigBarItemBase {
    type: 'price';
}

export interface FilterConfigBarItemSearchable extends FilterConfigBarItemBase {
    type: 'searchable';
    aggregationProperty: string;
    // aggregationProperty: keyof SearchServiceCompositeAggregationParams;
    searchInputPlaceholder: string;
    allowMultipleValues: boolean;
    allowAlphabeticalGrouping?: boolean;
}

export function isFilterConfigBarItemDefault(
    item: FilterConfigBarItem,
): item is FilterConfigBarItemDefault {
    return item.type === 'default';
}

export function isFilterConfigBarItemMultiple(
    item: FilterConfigBarItem,
): item is FilterConfigBarItemMultiple {
    return item.type === 'multiple';
}

export function isFilterConfigBarItemPrice(
    item: FilterConfigBarItem,
): item is FilterConfigBarItemPrice {
    return item.type === 'price';
}

export function isFilterConfigBarItemSearchable(
    item: FilterConfigBarItem,
): item is FilterConfigBarItemSearchable {
    return item.type === 'searchable';
}
